// Central API and Socket configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://noodlesbox.in/loopback";
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "https://noodlesbox.in/loopback";
